import { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { TFileExtension } from 'types';
import { downloadBlob } from 'backend/additionalInformation';
import { createAppError } from 'utils/helpers';

export const useBlobDownload = ({
	filePath,
	fileExtension,
	fileName,
	onError,
}: {
	filePath: Nullable<string>;
	fileExtension: TFileExtension;
	fileName: string;
	onError?: () => void;
}) => {
	const { showLoader, hideLoader, addAppError } = useContext<IAppContext>(AppContext);

	const blobDownload = async () => {
		if (filePath) {
			showLoader();
			try {
				const file = await downloadBlob(filePath);
				const href = URL.createObjectURL(file.data);

				const link = document.createElement('a');
				link.href = href;
				link.download = `${fileName}.${fileExtension}`;
				document.body.appendChild(link);
				link.click();

				document.body.removeChild(link);
				URL.revokeObjectURL(href);
				hideLoader();
			} catch (err) {
				hideLoader();
				if (onError) {
					onError();
				} else {
					addAppError(createAppError(err instanceof Error ? err : new Error(String(err))));
				}
			}
		}
	};

	return blobDownload;
};
